import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SignUpModal from '../components/SignUpModal';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [error, setError] = useState('');
  
  const { login, loginWithGoogle, isLoading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    const result = await login(email, password, rememberMe);
    
    if (result.success) {
      alert(`Welcome back, ${result.user.displayName || result.user.nickname || result.user.firstName}!`);
      navigate('/');
    } else {
      setError(result.error || 'Login failed. Please try again.');
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    
    const result = await loginWithGoogle();
    
    if (result.success) {
      alert(`Welcome, ${result.user.displayName || result.user.nickname || result.user.firstName}!`);
      navigate('/');
    } else {
      setError(result.error || 'Google login failed. Please try again.');
    }
  };

  const handleFacebookLogin = () => {
    // TODO: Integrate with Facebook OAuth
    console.log('Facebook login clicked');
    alert('Facebook authentication coming soon!');
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    const userEmail = prompt('Enter your email address to reset password:');
    if (userEmail) {
      alert(`Password reset link sent to ${userEmail} (Demo)`);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">
          Welcome to <span className="gradient-text">conneCT</span>
        </h1>
        <p className="login-subtitle">Sign in to connect with your community</p>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="rememberMe">Remember me for 30 days</label>
          </div>

          <button 
            type="submit" 
            className="btn btn-primary login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="login-divider">
          <span>or</span>
        </div>

        <div className="social-login">
          <button 
            className="btn btn-social google" 
            onClick={handleGoogleLogin}
            disabled={isLoading}
          >
            <span className="social-icon">G</span>
            Continue with Google
          </button>
          <button className="btn btn-social facebook" onClick={handleFacebookLogin}>
            <span className="social-icon">f</span>
            Continue with Facebook
          </button>
        </div>

        <div className="login-footer">
          <a href="#forgot" className="forgot-link" onClick={handleForgotPassword}>
            Forgot password?
          </a>
          <p className="signup-prompt">
            Don't have an account? 
            <button 
              className="signup-link" 
              onClick={() => setShowSignUp(true)}
            >
              Sign up
            </button>
          </p>
        </div>
      </div>
      
      <SignUpModal 
        isOpen={showSignUp} 
        onClose={() => setShowSignUp(false)} 
      />
    </div>
  );
}
